import { Component, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'rms-tab-host',
  standalone: true,
  template: `<ng-template #container></ng-template>`
})
export class TabHostComponent implements OnInit {
  @Input() component!: Type<any>;
  @Input() data: any;
  @Input() active = false;

  @ViewChild('container', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  ngOnInit(): void {
    this.refresh();
  }

  // Recreate only this screen so Angular runs its normal cleanup and load lifecycle.
  refresh(): void {
    this.container.clear();
    const ref = this.container.createComponent(this.component);
    Object.assign(ref.instance, this.data); // Pass @Input()s dynamically
  }
}
